import React, { useEffect, useState } from 'react';
import Transaction from './Transactions/Transaction';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import getCurrencySymbol, { getCountryInfo } from '../lib/currenyUtils';
import { Constants } from '../lib/const/constants';
import axios from 'axios';

function CurrencyDashboard() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = location.state;
  var paramsdata = Object.prototype.hasOwnProperty.call(params, 'params')
    ? params.params.data
    : params;
  const [showconvertTab, setshowconvertTab] = useState(false);
  const [loadingAccountDetails, setLoadingAccountDetails] = useState(false);
  const [iban, setIban] = useState();
  const [swift, setSwift] = useState();
  const [routingCode, setRoutingCode] = useState();
  const [bankName, setBankName] = useState("FX MASTER LIMITED");

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    var login_token = sessionStorage.getItem('login_token');
    setLoadingAccountDetails(true);
    await axios.post(Constants.BASE_URL + "API-FX-252-GET-ACCOUNT-DETAILS", {
      workspace_id: login_workspaces_id,
      currency: paramsdata.currency,
      platform: 'web',
      extraParamValidation: 'trustedfromweb'
    }, {
      headers: {
        Authorization: 'Bearer ' + JSON.parse(login_token),
        fx_key: Constants.SUBSCRIPTION_KEY,
      },
    }).then((resp) => {
      console.log(resp.data.data.account_meta);
      if (resp.data.success) {
        setIban(resp.data.data.account_meta.iban)
        setSwift(resp.data.data.account_meta.bic)
        setRoutingCode(resp.data.data.account_meta.routing_code)
        setBankName('ClearBank Limited')
      }
      setLoadingAccountDetails(false);
    }).catch(err => {
      console.log(err);
      setLoadingAccountDetails(false);
    })

    await axios
      .get(
        Constants.BASE_URL +
        'API-FX-165-CCTRANSACTIONS/' +
        login_workspaces_id +
        '?page=1&from=1970-01-01&to=1970-02-01',
        {
          headers: {
            Authorization: 'Bearer ' + JSON.parse(login_token),
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        },
      )
      .then((resp) => {
        console.log('menu tabs' + JSON.stringify(resp.data.menu));
        if (resp.data.menu.length > 0) {
          for (var m = 0; m < resp.data.menu.length; m++) {
            if (resp.data.menu[m].tab_id == 1) {
              setshowconvertTab(true);
            }
          }
          return true;
        }
      })
      .catch((err) => {
        console.log(err);
      });


    var login_id = sessionStorage.getItem('login_id');
    if (
      login_id == '' ||
      login_id == null ||
      login_token == '' ||
      login_token == null
    ) {
      sessionStorage.clear();
      navigate('/business');
    }
  };

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        padding: '32px 40px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: '#ffffff',
        backgroundImage: `linear-gradient(180deg, rgba(248,250,252,1) 0%, rgba(239,246,255,0.3) 50%, rgba(238,242,255,0.4) 100%)`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    >
      {/* Page Title */}
      <div
        style={{
          fontSize: 24,
          fontWeight: 700,
          color: '#394784',
          textAlign: 'center',
          marginBottom: 18,
        }}
      >
        Currency Details ({paramsdata.currency})
      </div>

      {/* Back Button */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          cursor: 'pointer',
          marginBottom: 18,
          width: '672px',
          justifyContent: 'flex-start',
        }}
        onClick={() => navigate(-1)}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          style={{ flexShrink: 0 }}
        >
          <path
            d="M19 12H5M5 12L11 18M5 12L11 6"
            stroke="#676F7D"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span style={{ fontSize: 20, fontWeight: 700, color: '#1D2338' }}>
          Back
        </span>
      </div>

      {/* Main Card */}
      <div
        style={{
          width: '700px',
          borderRadius: '16px',
          border: '1px solid #F2F2F2',
          background: '#FFFFFF',
          boxShadow: '0px 4px 16px rgba(0,0,0,0.06)',
          padding: '24px',
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
          boxSizing: 'border-box',
          marginBottom: '24px',
        }}
      >
        {/* Currency Header Row: flag + currency + balance + action buttons */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <span>
              {
                getCountryInfo(paramsdata.currency, { className: 'w-12 h-12' })
                  .flag
              }
            </span>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              <span style={{ fontSize: 16, fontWeight: 700, color: '#0B214E' }}>
                {getCurrencySymbol(paramsdata.currency)}
                {numberWithCommas(paramsdata.balance)}
              </span>
              <span style={{ fontSize: 13, fontWeight: 400, color: '#676F7D' }}>
                Available Balance
              </span>
            </div>
          </div>

          {/* Action Buttons */}
          <div style={{ display: 'flex', gap: 12 }}>
            <button
              onClick={() =>
                navigate('/sendMoney', {
                  state: {
                    currency: paramsdata.currency,
                    currencyid: paramsdata.currencyid,
                    balance: paramsdata.balance,
                    uri: paramsdata.flag,
                  },
                })
              }
              style={{
                height: '44px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                padding: '8px 20px',
                background: '#D26521',
                color: '#FFFFFF',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: 600,
                cursor: 'pointer',
                boxSizing: 'border-box',
                boxShadow: '0px 4px 24px rgba(157, 79, 26, 0.36)',
              }}
            >
              Pay
              <svg width="17" height="18" viewBox="0 0 24 24" fill="none">
                <path
                  d="M5 12h12M13 6l6 6-6 6"
                  stroke="#FFFFFF"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>

            {showconvertTab && (
              <button
                onClick={() =>
                  navigate('/Conversions', {
                    state: {
                      currency: paramsdata.currency,
                      currencyid: paramsdata.currencyid,
                      balance: paramsdata.balance,
                      uri: paramsdata.flag,
                    },
                  })
                }
                style={{
                  height: '44px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '8px 20px',
                  background: 'transparent',
                  color: '#0B214E',
                  border: '1.5px solid #0B214E',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  boxSizing: 'border-box',
                }}
              >
                Convert
              </button>
            )}
          </div>
        </div>

        {/* Currency Details Inner Box — only for GBP (currencyid 231) */}
        {paramsdata.currencyid == 231 ? (
          <div
            style={{
              width: '100%',
              borderRadius: '12px',
              border: '1px solid #E6E5E5',
              background: '#FCFCFC',
              padding: '24px',
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              boxSizing: 'border-box',
            }}
          >
            <div
              style={{
                fontSize: 15,
                fontWeight: 700,
                color: '#203358',
                marginBottom: 4,
              }}
            >
              Currency Details
            </div>

            <div style={rowStyle}>
              <span style={labelStyle}>Account Name</span>
              <span style={valueStyle}>{paramsdata.accountName}</span>
            </div>

            <div style={rowStyle}>
              <span style={labelStyle}>Account Number</span>
              <span style={valueStyle}>{paramsdata.accountNumber}</span>
            </div>

            <div style={rowStyle}>
              <span style={labelStyle}>Sort Code</span>
              <span style={valueStyle}>{paramsdata.sortcode}</span>
            </div>

            {/* <div style={rowStyle}>
              <span style={labelStyle}>IBAN No</span>
              <span style={valueStyle}>{paramsdata.Iban || '-'}</span>
            </div> */}

            <div style={rowStyle}>
              <span style={labelStyle}>Currency</span>
              <span style={valueStyle}>{paramsdata.currency}</span>
            </div>
          </div>
        ) :
          <>
            {!loadingAccountDetails && paramsdata.currencyid!=105 &&
              <div
                style={{
                  width: '100%',
                  borderRadius: '12px',
                  border: '1px solid #E6E5E5',
                  background: '#FCFCFC',
                  padding: '24px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '20px',
                  boxSizing: 'border-box',
                }}
              >
                <div
                  style={{
                    fontSize: 15,
                    fontWeight: 700,
                    color: '#203358',
                    marginBottom: 4,
                  }}
                >
                  Currency Details
                </div>

                <div style={rowStyle}>
                  <span style={labelStyle}>Account Name</span>
                  <span style={valueStyle}>{paramsdata.accountName}</span>
                </div>
                {iban || paramsdata.Iban &&
                  <div style={rowStyle}>
                    <span style={labelStyle}>IBAN No</span>
                    <span style={valueStyle}>{iban || paramsdata.Iban}</span>
                  </div>
                }

                <div style={rowStyle}>
                  <span style={labelStyle}>Swift Code</span>
                  <span style={valueStyle}>{swift || "FMLTGB22XXX"}</span>
                </div>
                {routingCode &&
                  <div style={rowStyle}>
                    <span style={labelStyle}>Routing Code</span>
                    <span style={valueStyle}>{routingCode}</span>
                  </div>
                }

                <div style={rowStyle}>
                  <span style={labelStyle}>Bank Name</span>
                  <span style={valueStyle}>{bankName}</span>
                </div>

                <div style={rowStyle}>
                  <span style={labelStyle}>Bank Address</span>
                  <span style={valueStyle}>30 Churchill Place, Canary Wharf, London, England, E14 5RE</span>
                </div>
                <div style={rowStyle}>
                  <span style={labelStyle}>Currency</span>
                  <span style={valueStyle}>{paramsdata.currency}</span>
                </div>
              </div>
            }
          </>
        }
      </div>

      {/* Transactions Card */}
      <div>
        <Transaction filtercurrency={paramsdata.currency} />
      </div>
    </div>
  );
}

const rowStyle = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
};

const labelStyle = {
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '100%',
  letterSpacing: '0px',
  color: '#676F7D',
  width: '200px',
  flexShrink: 0,
};

const valueStyle = {
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '100%',
  letterSpacing: '0px',
  color: '#1D2338',
  textAlign: 'left',
  wordBreak: 'break-word',
};

export default CurrencyDashboard;